import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { AiFillCloseCircle } from 'react-icons/ai';

const baseStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  transition: 'border .3s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

let nextId = 0;

function DropzoneComponent(props) {

  const onDrop = useCallback(acceptedFiles => {
    props.setFiles(prevFiles => [...prevFiles, ...acceptedFiles])
  }, []);

  const handleRemoveDoc = (fileName) => {
    props.setFiles(prevFiles => prevFiles.filter(prevFile => prevFile.name !== fileName))
  }

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop,
    uploadMultiple: true,
    addRemoveLinks: true
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  const thumbs = props.files.map((file, indx)=> {
    return (
      <div key={indx} className="flex pt-[15px]">
      <span
        className="inline-block relative whitespace-nowrap rounded-full mr-2 bg-orange-500 p-2 text-center align-baseline text-[0.75em] font-bold leading-none text-white">
        {file?.name} <AiFillCloseCircle onClick={()=> handleRemoveDoc(file.name)} size={20} color="red" className="absolute top-[-10px] right-[-6px] cursor-pointer" />
      </span>
      </div>
    )
});

  return (
    <section>
      <div {...getRootProps({style})}>
        <input {...getInputProps()} />
        <div>Drag and drop your documents here.</div>
      </div>
      <aside className="flex flex-wrap">
        {thumbs}
      </aside>
    </section>
  )
}

export default DropzoneComponent;